import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
meta: { requiresAuth: true }
  },
    {
    path: '/dashboard',
    name: 'dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/DashboardView.vue')
    },
meta: { requiresAuth: true }
  },
      {
    path: '/coachee',
    name: 'coachee',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/MentoradoView.vue')
    },
meta: { requiresAuth: true }
  },
        {
    path: '/graficomentoria',
    name: 'graficomentoria',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/GraficoMentorias.vue')
    },
meta: { requiresAuth: true }
  },
    {
    path: '/sessoes',
    name: 'sessoes',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/MentoriaView.vue')
    },
meta: { requiresAuth: true }
  },
   {
    path: '/progresso',
    name: 'progresso',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ProgressoView.vue')
    },
meta: { requiresAuth: true }
  },
     {
    path: '/inscricao',
    name: 'inscricao',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/inscricaoView.vue')
    },
meta: { requiresAuth: true }
  },
       {
    path: '/individual',
    name: 'individual',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/individualView.vue')
    },
meta: { requiresAuth: true }
  },
         {
    path: '/detalhe',
    name: 'detalhe',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/DetalheView.vue')
    },
meta: { requiresAuth: true }
  },         {
    path: '/MostrarDetalhe',
    name: 'MostrarDetalhe',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/MostrarDetalheView.vue')
    },
meta: { requiresAuth: true }
  },
      {
    path: '/coach',
    name: 'coach',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/CoachingView.vue')
    },
meta: { requiresAuth: true }
  },

{
  path: '/detalheCoach/:id',
  name: 'detalheCoach',
  component: () => import('../views/DetalheCoachView.vue')
  ,
meta: { requiresAuth: true }
},

{
  path: '/detalheFormando/:id',
  name: 'detalheCoachee',
  component: () => import('../views/DetalheFormandoView.vue')
  ,
meta: { requiresAuth: true }
},
{
  path: '/reagendadas',
  name: 'reagendadas',
  component: () => import('../views/MentoriasReagendadas.vue')
  ,
meta: { requiresAuth: true }
},
{
  path: '/utilizadores',
  name: 'utilizadores',
  component: () => import('../views/UtilizadoresView.vue')
  ,
meta: { requiresAuth: true }
},
{
  path: '/utilizadores',
  name: 'utilizadores',
  component: () => import('../views/UtilizadoresView.vue')
  ,
meta: { requiresAuth: true }
},
{
  path: '/utilizadores',
  name: 'utilizadores',
  component: () => import('../views/UtilizadoresView.vue')
  ,
meta: { requiresAuth: true }
},
{
  path: '/BusinessPartners',
  name: 'BusinessPartners',
  component: () => import('../views/BusinessPartners.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/VerCoachesBP/:bpId',
  name: 'VerCoacheesBP',
  component: () => import('../views/VerCoachesBP.vue'),
 
  meta: { requiresAuth: true }
},
{
  path: '/Vercoachees/:id',
  name: 'Vercoachees',
  component: () => import('../views/VercoacheesVue.vue'),
  meta: { requiresAuth: true }
}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  const estaLogado = !!localStorage.getItem('authToken')  // verifica se tem token

  if (to.meta.requiresAuth && !estaLogado) {
    // se a rota precisa de login e não está logado, vai para login
    next({ name: 'login' })
  } else if (to.name === 'login' && estaLogado) {
    // se já está logado e tenta ir para login, redireciona para dashboard
    next({ name: 'dashboard' })
  } else {
    // caso contrário, deixa passar
    next()
  }
})

export default router
